module.exports = __webpack_public_path__ + "static/assets/3373c0f7000278a0926cb9eff8ec317e.svg";